<template>
  <v-hover>
    <!-- <template v-slot:default="{ hover }"> -->
    <template>
      <v-card :ripple="false" :to="{ name: $constants.ROUTE_NAME.PRODUCT_DETAIL, params: { productId: productInfo.id } }" class="elevation-0 transparent">
        <v-card-title class="elevation-2 rounded mb-2 store-item pa-0">
          <v-img class="rounded" :src="productInfo.image" aspect-ratio="1" :style="{ opacity: outOfStock ? 0.65 : 1 }"></v-img>
          <div v-if="outOfStock" class="sold-out-label pa-2 text-subtitle-2 font-weight-bold secondary lighten-1 text-center white--text rounded-pill">
            <span>{{ $t('label.soldOut') }}</span>
          </div>
          <div
            v-if="(productInfo.volume_variation === 0 && productInfo.discount_percentage != 0) || (productInfo.volume_variation === 1 && productInfo.volume_variations[0].discount_percentage != 0)"
            class="discount font-weight-bold primary lighten-1 d-flex flex-column align-center justify-center white--text rounded-circle"
          >
            <span>{{ `${productInfo.volume_variation === 0 ? productInfo.discount_percentage : productInfo.volume_variations[0].discount_percentage}` }}%</span>
            <span>{{ $t('label.discountOff') }}</span>
          </div>
          <!-- <v-fade-transition>
            <v-overlay v-if="hover" absolute color="secondary">
              <app-button :solid="true" :label="$t('label.addToCart')" @click.native.prevent="addToCart"></app-button>
            </v-overlay>
          </v-fade-transition> -->
        </v-card-title>
        <v-card-text v-if="!hideDetails" class="px-0 text-left">
          <p class="text-truncate text-mini light-grey--text">
            {{ productInfo.brand_name }}
          </p>
          <p
            class="text-truncate text-mini secondary--text"
            :class="{
              'font-weight-bold': hideRatings
            }"
          >
            {{ productInfo.product_name }}
          </p>
          <div>
            <div class="d-flex flex-row font-weight-medium text-caption grey--text text--darken-2 flex-nowrap mt-1" style="line-height: 120%">
              <p>{{ $t('label.retailPrice') }}:</p>
              <div class="ml-2 d-flex flex-column flex-xl-row">
                <span
                  :class="{
                    'text-decoration-line-through': isDiscounted
                  }"
                >
                  {{ `${productInfo.currency} ${formatPrice(unitPrice)}` }}
                </span>
                <span v-if="isDiscounted" class="font-weight-bold ml-xl-2">
                  {{ `${productInfo.currency} ${formatPrice(discountedPrice)}` }}
                </span>
              </div>
            </div>
            <div v-if="partnerPrice" class="d-flex flex-row font-weight-medium text-caption orange--text">
              {{ $t('label.partnerPrice') }}:
              <p class="ml-2">{{ `${productInfo.currency} ${formatPrice(partnerPrice)}` }}</p>
            </div>
          </div>
          <div v-if="!hideRatings">
            <p class="font-weight-medium text-caption light-grey--text text--darken-1">
              {{ $t('label.points') }}: {{ productInfo.volume_variation === 0 ? productInfo.points_to_redeem || $t('label.notAvailable') : productInfo.volume_variations[0].points_to_redeem || 'N/A' }}
            </p>
            <div class="d-flex justify-space-between">
              <Rating :value="(productInfo.rate_percent / 100) * 5" backgroundColor="grey" color="primary lighten-1" empty-icon="mdi-star" small dense readonly />
              <v-btn v-if="wishlist.length > 0 && wishlist.findIndex((f) => f.id === productInfo.id) > -1" @click.native.prevent="removeFromWishlist" icon>
                <v-icon color="primary">$heart_full</v-icon>
              </v-btn>
              <v-btn v-else @click.native.prevent="addToWishlist" icon><v-icon color="primary">$heart</v-icon></v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </template>
    <!-- </template> -->
  </v-hover>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Rating from '@/components/Rating.vue'
import { uiHelper } from '@/utils'

export default {
  props: {
    productInfo: {
      type: Object,
      required: true,
      default: () => {}
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: false
    },
    hideRatings: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: { Rating },

  computed: {
    ...mapState('auth', ['currentUser']),
    ...mapState('wishlist', ['wishlist']),
    outOfStock() {
      let res = this.productInfo.stock_status == 'Out of Stock'
      if (this.productInfo.volume_variation === 1) {
        if (this.productInfo.volume_variations.length === this.productInfo.volume_variations.filter((f) => f.stock_status === 'Out of Stock').length) res = true
        else res = false
      }
      return res
    },
    isDiscounted() {
      let res = false
      if (this.productInfo.volume_variation === 0) res = this.productInfo.discounted_price != null && this.productInfo.discounted_price != ''
      else res = this.productInfo.volume_variations[0].discounted_price != null && this.productInfo.volume_variations[0].discounted_price != ''
      return res
    },
    partnerPrice() {
      let res = this.productInfo.agent_price
      if (this.productInfo.volume_variation === 1) {
        let filteredArr = this.productInfo.volume_variations.filter((f) => f.stock_status !== 'Out of Stock')
        if (this.productInfo.volume_variations.length === this.productInfo.volume_variations.filter((f) => f.stock_status === 'Out of Stock').length)
          res = this.productInfo.volume_variations[0].agent_price
        else res = filteredArr[0].agent_price
      }
      return res
    },
    unitPrice() {
      let res = this.productInfo.unit_price
      if (this.productInfo.volume_variation === 1) {
        let filteredArr = this.productInfo.volume_variations.filter((f) => f.stock_status !== 'Out of Stock')
        if (this.productInfo.volume_variations.length === this.productInfo.volume_variations.filter((f) => f.stock_status === 'Out of Stock').length)
          res = this.productInfo.volume_variations[0].unit_price
        else res = filteredArr[0].unit_price
      }
      return res
    },
    discountedPrice() {
      let res = this.productInfo.discounted_price
      if (this.productInfo.volume_variation === 1) {
        let filteredArr = this.productInfo.volume_variations.filter((f) => f.stock_status !== 'Out of Stock')
        if (this.productInfo.volume_variations.length === this.productInfo.volume_variations.filter((f) => f.stock_status === 'Out of Stock').length)
          res = this.productInfo.volume_variations[0].discounted_price
        else res = filteredArr[0].discounted_price
      }
      return res
    }
  },

  methods: {
    ...mapActions('wishlist', ['addWishlist', 'deleteWishlist']),
    addToCart() {
      console.log('asd')
    },
    async addToWishlist() {
      if (this.currentUser) await this.addWishlist({ product_id: this.productInfo.id })
      else this.$root.$app.openLoginDialog()
    },
    async removeFromWishlist() {
      let index = this.wishlist.findIndex((f) => f.id === this.productInfo.id)
      await this.deleteWishlist([this.wishlist[index].wish_id])
    },
    formatPrice(val) {
      return uiHelper.priceFormatter(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.store-item {
  position: relative;
}

.sold-out-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
}

.discount {
  position: absolute;
  right: 4%;
  top: 3%;
  height: 40px;
  width: 40px;
  font-size: 0.75rem;
  line-height: 1;

  @media only screen and (min-width: 640px) {
    height: 50px;
    width: 50px;
    font-size: 0.8rem;
  }
  @media only screen and (min-width: 1800px) {
    height: 80px;
    width: 80px;
    font-size: 1.4rem;
  }
}
</style>
